import { normalizeCurp } from './curp'

// Avisar cuando el jugador que se está capturando ya existe.
//
// El caso real no es "el mismo nombre exacto" -- ese casi nunca pasa dos veces. Lo
// que pasa es que la misma persona se escribe distinto: con acentos y sin ellos, con
// un solo apellido, con "Ma." en vez de "María". Por eso la comparación es por
// PALABRAS y no por cadena.
//
// Regla: una es sospechosa de la otra cuando TODAS las palabras de la más corta
// están en la más larga, y la más corta tiene al menos dos. Así:
//
//   "Renata Campos"  ~  "Renata Campos Morales"   -> avisa
//   "RENATA CAMPOS MORALES"  ~  "Renata Campos Morales" -> avisa
//   "Renata Campos"  ~  "Renata Duarte"           -> no (solo comparten una)
//
// Avisa, no bloquea: dos hermanos pueden llamarse parecido y los homónimos existen.
// Impedir un alta legítima sería peor que la duplicación que se quiere evitar.

export const palabrasNombre = (nombre) =>
  String(nombre || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)

export const nombresParecidos = (a, b) => {
  const pa = palabrasNombre(a)
  const pb = palabrasNombre(b)
  if (pa.length < 2 || pb.length < 2) return false

  const [corta, larga] = pa.length <= pb.length ? [pa, pb] : [pb, pa]
  const enLarga = new Set(larga)
  return corta.every((p) => enLarga.has(p))
}

// Coincidencias de un jugador que se está capturando contra el padrón.
// `motivo` dice por qué coincide, porque no es lo mismo: una CURP repetida es un
// duplicado casi seguro; un nombre parecido puede ser un hermano.
export const buscarCoincidencias = ({ nombre, curp }, jugadores = [], excluirId = null) => {
  const curpNorm = normalizeCurp(curp)
  const resultados = []

  for (const j of jugadores) {
    if (!j || j.id === excluirId) continue

    if (curpNorm && normalizeCurp(j.curp) === curpNorm) {
      resultados.push({ ...j, motivo: 'curp' })
      continue
    }
    if (nombre && nombresParecidos(nombre, j.nombre_completo)) {
      resultados.push({ ...j, motivo: 'nombre' })
    }
  }

  // La CURP primero: es la señal fuerte.
  return resultados
    .sort((a, b) => (a.motivo === 'curp' ? -1 : 0) - (b.motivo === 'curp' ? -1 : 0))
    .slice(0, 4)
}
